export default __webpack_public_path__ + "static/media/gallery_03.4a27ece9.jpg";